import React from "react";
import ReactDOM from "react-dom/client";
import { installDomSafetyPatch } from "./lib/domSafetyPatch";
import "./index.css";
import "./i18n";
import App from "./App";

// Guard React's reconciler against third-party DOM mutation (PostHog/rrweb,
// Emergent visual edits, download helpers, browser extensions) that otherwise
// crashes route changes with "removeChild ... not a child of this node".
installDomSafetyPatch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
